import React, { useEffect } from "react";
import Editor from "../../../elements/tiptap-editor/Editor.js";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { postAddEdit } from "../../../../services/postService";
import { useMutation } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";

const validation = {
  title: { required: true, message: "Title is required" },
  content: { required: true, message: "Content is required" },
};

const ManageHowItWorks = ({ getResponse = () => {}, close = () => {}, data }) => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        type: "how-it-works",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-4">
          <Input
            label="Title"
            inputPlaceholder="title"
            onChange={handleChange}
            inputName={"title"}
            required={false}
            value={values?.title}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="Content"
            height={200}
            placeholder="content"
            value={values?.content}
            onChange={(val) =>
              handleChange({
                target: { name: "content", value: val },
              })
            }
            {...formValidate(errors, "content")}
          />
        </div>
        {/* <div className="flex items-start gap-4">
          <Input
            label={"InActive"}
            inputPlaceholder={"Enter"}
            inputName="inActive"
            value={values?.inActive}
            onChange={handleChange}
            {...formValidate(errors, "inActive")}
          />
          <div className="w-full"></div>
        </div> */}
      </div>
      <div className="pt-3 p-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonClasses={"min-w-36"}
          buttonLabel={data?._id ? "Update" : "Save"}
          {...((isLoading || detailsLoading) && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </form>
  );
};

export default ManageHowItWorks;
